const Footer = () => {

    const links = [
        {name: 'Email', url: 'mailto:joshy.d.simon@gmail.com'},
        {name: 'GitHub', url: 'https://github.com/joshua-simon/'},
        {name: 'LinkedIn', url: 'https://www.linkedin.com/in/joshua-simon-53078768/'},
        {name: 'Music', url: 'https://soundcloud.com/josh-simon-264281792'}
    ]

    return (
        <footer className="site-footer">
            <p>© {new Date().getFullYear()} Joshua Simon · Wellington, NZ</p>
            <div className="footer-links">
                {links.map(link => <a href = {link.url} key = {link.name} target="_blank" rel="noreferrer">{link.name}</a>)}
            </div>
        </footer>
    )
}

export default Footer;
